import cookie from 'react-cookie';
import moment from 'moment';
import config from '../config.js';
import api from '../api';
import lct from '../helpers/location';
import UserStore from '../stores/UserStore';

const cookOptions = {path: '/'};
const nameCookieLastTimeUpdateRefreshToken = 'b4250c462007ab4e646a8e1faf2e5cc5';
const ignoreIntervalUpdateToken = 1800; // seconds
let AccessTokenIsDeleted = false;

const _getCurrentTimeInUtc = () => {
    return moment.utc().unix();
};

const _getLastUpdateTime = () => {
    return cookie.load(nameCookieLastTimeUpdateRefreshToken) || 0;
};

const _checkUpdateTokenForwarding = () => {
    let cutTime = _getCurrentTimeInUtc();
    let lastUpdateTime = _getLastUpdateTime();
    let deltaTime = cutTime - lastUpdateTime;

    return lastUpdateTime && deltaTime <= ignoreIntervalUpdateToken && deltaTime >= 0;
};

const SessionActions = {
    authorize(success, loading) {
        const hashData = lct.parse(window.location.hash);
        const accessDate = cookie.load(config.nameCookie);
        const isAccessTokenHash = hashData.access_token;
        const isImpersonatingUser = hashData.impersonating_user || accessDate && accessDate.impersonating_user;

        if (isImpersonatingUser) {
            UserStore.setImpersonating(isImpersonatingUser);
        }

        if (!isAccessTokenHash && !accessDate) {
            SessionActions.getAccessToken();
        } else {
            if (isAccessTokenHash) {
                hashData.createdCookTime = _getCurrentTimeInUtc();
                cookie.save(config.nameCookie, hashData, cookOptions);
            }

            if (SessionActions.authentication()) {
                success();
                SessionActions.updateRefreshToken();
            } else {
                loading();
                SessionActions.updateRefreshToken(success);
            }
        }

        window.location.hash && (window.location.hash = '');
    },

    deleteAccessToken() {
        AccessTokenIsDeleted = true;
        cookie.remove(config.nameCookie, cookOptions);
        cookie.remove(nameCookieLastTimeUpdateRefreshToken, cookOptions);
    },

    getAccessToken() {
        if (!AccessTokenIsDeleted) {
            api.getAccessToken();
        }
    },

    saveAccessData(accessData = {}) {
        let oldAccessData = SessionActions.getAccessData();

        accessData = {
            ...oldAccessData,
            ...accessData,
            impersonating_user: UserStore.getImpersonating()
        };

        cookie.save(config.nameCookie, accessData, cookOptions);
    },

    /** @returns {Object} */
    getAccessData() {
        return cookie.load(config.nameCookie) || {};
    },

    updateRefreshToken(callback) {
        let accessData = SessionActions.getAccessData();
        let params = {
            refresh_token: accessData.refresh_token,
            client_id: config.clientId
        };

        if (!params.refresh_token) {
            SessionActions.getAccessToken();
        }

        if (_checkUpdateTokenForwarding()) {
            setTimeout(SessionActions.updateRefreshToken, SessionActions.getTimeUpdateRefreshToken());

            callback && callback();
        } else {
            cookie.save(nameCookieLastTimeUpdateRefreshToken,  _getCurrentTimeInUtc(), cookOptions);

            api.updateRefreshToken(params).then((resp) => {
                SessionActions.saveAccessData(resp);

                setTimeout(SessionActions.updateRefreshToken, SessionActions.getTimeUpdateRefreshToken());

                callback && callback();
            }).catch(() => {
                SessionActions.getAccessToken();
            });
        }
    },

    authentication() {
        let data = SessionActions.getAccessData();
        let cutTime = _getCurrentTimeInUtc();
        let deltaTime = data.expires_at - data.created_at;
        let lastUpdateTime = _getLastUpdateTime();

        return cutTime < lastUpdateTime + deltaTime;
    },

    getTimeUpdateRefreshToken() {
        let data = SessionActions.getAccessData();
        let deltaTime = data.expires_at - data.created_at;

        return deltaTime * config.percentTimeUpdateToken * 1000;
    },

    saveUserID() {
        let accessData = SessionActions.getAccessData();
        accessData.userID = UserStore.getID();

        SessionActions.saveAccessData(accessData);
    },

    userAuthentication() {
        const accessData = SessionActions.getAccessData();

        if (accessData.userID && UserStore.getID() && accessData.userID !== UserStore.getID()) {
            window.location.reload();
        }
    },

    isLoopToken() {
        return SessionActions.getAccessData().createdCookTime === _getCurrentTimeInUtc();
    },
};

export default SessionActions;
